<template>
  <div :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      代理商信息
    </div>
    <div class="custom-base-info">
      <div class="item">
        <div class="label">
          所属代理商
        </div>
        <div class="value">
          {{ baseInfo.companyBase?.agentName }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          企业类型
        </div>
        <div class="value">
          {{ companyTypeLabel[baseInfo.companyBase?.type] }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          销售
        </div>
        <div class="value">
          {{ baseInfo.companyBase?.businessUserName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { companyTypeLabel, ICompanyMergeInfo } from '@core/main/types';
import { inject } from 'vue';

defineOptions({ name: 'BaseInfo' }); // 账户中心 - 企业基本信息

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

const baseInfo = inject('baseInfo') as ICompanyMergeInfo;
</script>
